/**
 * Route for `report-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReportApiPage } from "../features/report-api/ReportApiPage";

export const reportApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/report-api",
	component: ReportApiPage,
});

export default reportApiRoute;
